import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEffectiveMe } from '@/lib/effectiveMe';
import { useSelfEmployee } from '@/lib/selfIdentity';
import { hasCap, isPureEmployee } from '@/lib/capabilities';
import Attendance from '@/pages/Attendance';
import EmployeeAttendanceHistory from '@/pages/EmployeeAttendanceHistory';

export default function AttendanceRoute() {
  const me = useEffectiveMe();
  const { isSimulated } = useSelfEmployee();

  if (isSimulated) return <Navigate to="/foundation" replace />;
  if (hasCap(me, 'attendance.view')) return <Attendance />;
  if (isPureEmployee(me) && hasCap(me, 'attendance.self')) return <EmployeeAttendanceHistory />;
  return <Navigate to="/access-denied" replace />;
}
